/** @jsx jsx */

import { Icon } from '@zapier/zinnia-icons';
import { jsx } from '@emotion/core';

import { Button } from '@zapier/design-system';

type Props = {
  onClick: () => void;
};

const VersioningHelpButton = ({ onClick }: Props) => {
  return (
    <Button variant="secondary" onPress={onClick} iconPosition="start">
      <Icon name="navHelpFill" />
      What is versioning?
    </Button>
  );
};

export default VersioningHelpButton;
